var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-bar",style:({
    background: _vm.outerBackgroundColor,
    height: _vm.height,
    lineHeight: _vm.height
  })},[_c('ul',{staticClass:"tabs",style:({
      height: _vm.height,
      width: _vm.outerLeftWidth,
      color: _vm.innerTextColor
    })},[_vm._t("default")],2),(_vm.hasOptions)?_c('div',{staticClass:"options",style:({
      width: _vm.outerRightWidth,
      color: _vm.innerTextColor
    })},[_vm._t("options")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }